import {
    Promotion,
    PromotionDto,
} from '@app/promotions/types';

export function transformPromotion(dto: PromotionDto): Promotion {
    return dto;
}
